import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import Home from "./pages/Home";
import AllProducts from "./pages/AllProducts";
import DetailProduct from "./pages/DetailProduct";
import Cart from "./pages/Cart";
import Account from "./pages/Account";
import Promotion from "./pages/Promotion";
import ResetPassword from "./components/ResetPassword";
import AboutUs from "./pages/AboutUs";
import SearchPage from "./components/SearchPage";
import ScrollToTopButton from "./pages/ScrollToTopButton";
import NotFound from "./pages/NotFound";
import { countUniqueVisit } from "./Visitors";

import "react-toastify/dist/ReactToastify.css";

import { CartProvider } from "./CartProvider";
import { LoginProvider } from "./LoginProvider";
import SucessOrder from "./pages/SucessOrder";
import { LocationFeeProvider } from "./context/LocationFeeContext";

import "./App.css";

function FacebookPixelPageView() {
  const location = useLocation();

  useEffect(() => {
    if (window.fbq) {
      window.fbq("track", "PageView");
    }
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    countUniqueVisit();
  }, []);

  return (
    <LoginProvider>
      <CartProvider>
        <LocationFeeProvider>
          <Router>
            <FacebookPixelPageView />

            <div className="App">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<AllProducts />} />
                <Route path="/details/:id" element={<DetailProduct />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/compte/" element={<Account />} />
                <Route path="/promotions" element={<Promotion />} />
                <Route path="/forgot" element={<ResetPassword />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/search" element={<SearchPage />} />
                <Route path="/success-order" element={<SucessOrder />} />
                <Route path="*" element={<NotFound />} />
              </Routes>

              <ScrollToTopButton />
            </div>
          </Router>
        </LocationFeeProvider>
      </CartProvider>
    </LoginProvider>
  );
}

export default App;
